/**
 * @packageDocumentation
 * @module api.functional.companies.subsidiary
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { CreateCompanyResponseDto } from "../../../structures/CreateCompanyResponseDto";
import type { CreateSubsidiaryDto } from "../../../structures/CreateSubsidiaryDto";
import type { InvitationResultDto } from "../../../structures/InvitationResultDto";

/**
 * @controller CompanyExternalController.createSubsidiary
 * @path POST /companies/subsidiary
 * @accessor api.functional.companies.subsidiary.createSubsidiary
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function createSubsidiary(
  connection: IConnection,
  body: createSubsidiary.Body,
): Promise<createSubsidiary.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...createSubsidiary.METADATA,
      template: createSubsidiary.METADATA.path,
      path: createSubsidiary.path(),
    },
    body,
  );
}
export namespace createSubsidiary {
  export type Body = CreateSubsidiaryDto;
  export type Output = {
    ack: true;
    company: CreateCompanyResponseDto;
    invitations: InvitationResultDto[];
  };

  export const METADATA = {
    method: "POST",
    path: "/companies/subsidiary",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = () => "/companies/subsidiary";
}
